import { mapState } from 'vuex'
import Timeline from '@/components/Timeline'
import LearnMore from '@/components/LearnMore'
import { bus } from '@/consts.js'
import SvgLib from '@/components/SvgLib'

export default {
  name: 'MobileNav',
  template: '#mobilenav-template',
  components: {Timeline, LearnMore, SvgLib},
  data () {
    return {
      open: false,
      currentLink: 0
    }
  },
  computed: {
    bkg () {
      return this.$route.name === 'hero' || this.$route.name === 'start'
    },
    currentTransform () {
      return this.map[this.currentLink].translate
    },
    ...mapState({
      map: state => state.timelineLinks
    })
  },
  methods: {
    updateProgress () {
      let idx = this.map.findIndex(link => link.name === this.$route.name)
      const pathParts = this.$route.path.split('/')

      if (idx < 0 && pathParts.length === 3) {
        idx = this.map.findIndex(link => link.name === pathParts[1])
      } else if (idx < 0 && pathParts.length === 4) {
        idx = this.map.findIndex(link => link.name === pathParts[2])
      }

      if (idx >= 0) {
        this.currentLink = this.map[idx].index
        this.map.map(link => this.$store.dispatch('deactivateTimelineLink', link))
        if (!this.map[this.currentLink].unlocked) {
          this.$store.dispatch('unlockTimelineLink', this.map[this.currentLink])
        } else {
          this.$store.dispatch('activateTimelineLink', this.map[this.currentLink])
        }
      }
    },
    openNav () {
      this.open ? this.open = false : this.open = true
      if (this.$route.name !== 'hero' && this.$route.name !== 'start') {
        if (this.open) {
          document.body.classList.add('sub-bar-visible')
        } else {
          document.body.classList.remove('sub-bar-visible')
        }
      }
    }
  },
  watch: {
    '$route' () {
      this.updateProgress()
    }
  },
  mounted () {
    this.updateProgress()

    bus.$on('closeNav', () => {
      this.open = false
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/MobileNav.js